import styled from "styled-components";
import React, {useEffect} from "react";
import useKeyToClose from "../../helpers/useKeyToClose";
import useScrollLock from "../../hooks/useScrollLock";

const OverlayWrapper = styled.div`
    --fits--vertical-padding: 24px;
    --fits--horizontal-padding: 24px;
    
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000;
    
    @media screen and (min-width: 600px) {
        --fits--vertical-padding: 32px;
        --fits--horizontal-padding: 32px;
    }

`;
const OverlayBackground = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(51, 60, 84, 0.50);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    container-type: size;
    container-name: overlay;
    pointer-events: all;

    @media screen and (min-width: 768px) {
        align-items: center;
    }
`;

export const OverlayContainer = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 1;
    background-color: var(--wp--preset--color--white-shade);
    border-radius: 0;
    overflow: auto;
    max-height: 100%;
    height: 100%;
    width: 100%;

    @media screen and (min-width: 768px) {
        width: 600px;
        max-height: calc(100% - 120px);
        border-radius: 40px;
        height: auto;
    }
`


export function Overlay( {children, onClose, isOpen, className} ) {
  const{
    lockScroll,
    unlockScroll,
  } = useScrollLock();

  useEffect( () => {
    if(isOpen) {
      lockScroll()
    }

    return () => {
      unlockScroll()
    }
  }, [isOpen, unlockScroll, lockScroll] );

  function handleClose() {
    unlockScroll()
    if ( onClose ) onClose();
  }

  useKeyToClose( isOpen, handleClose );

  return (
    <OverlayWrapper>
      <OverlayBackground
        onClick={() => {
          handleClose()
        }}
      />
      <OverlayContainer className={className}>
        {children}
      </OverlayContainer>
    </OverlayWrapper> );
}
